/* eslint-disable unused-imports/no-unused-vars */
import React from 'react';
import {
  Box,
  Slider,
  InputAdornment,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import Typography from '@/components/typography/typography';
import TextField from '@/components/text-field/text-field';

interface SignatureControlsProps {
  attrs: Record<string, any>;
  updateAttrs: (attr: Record<string, any>) => void;
}

const SignatureControls: React.FC<SignatureControlsProps> = ({
  attrs,
  updateAttrs,
}) => {
  const { styles } = attrs
  return (
    <>
      <Box sx={{ mb: 2 }}>
        <TextField
          label="Signature Name"
          value={attrs?.signatureText || ''}
          onChange={(e) => updateAttrs({ signatureText: e.target.value })}
          fullWidth
          placeholder="e.g. John Doe"
        />
      </Box>

      <Box sx={{ mb: 2 }}>
        <FormControl fullWidth size="small">
          <InputLabel>Font Family</InputLabel>
          <Select
            value={styles?.fontFamily || 'Arial, sans-serif'}
            onChange={(e) => updateAttrs({ styles: { fontFamily: e.target.value } })}
            label="Font Family"
          >
            <MenuItem value="Arial, sans-serif">Arial</MenuItem>
            <MenuItem value="'Times New Roman', serif">Times New Roman</MenuItem>
            <MenuItem value="'Courier New', monospace">Courier New</MenuItem>
            <MenuItem value="Georgia, serif">Georgia</MenuItem>
            <MenuItem value="Verdana, sans-serif">Verdana</MenuItem>
            <MenuItem value="'Brush Script MT', cursive">Brush Script (Cursive)</MenuItem>
            <MenuItem value="'Lucida Handwriting', cursive">Lucida Handwriting (Cursive)</MenuItem>
            <MenuItem value="'Alex Brush', cursive">Alex Brush (Cursive)</MenuItem>
            <MenuItem value="'Allura', cursive">Allura (Cursive)</MenuItem>
            <MenuItem value="'Dancing Script', cursive">Dancing Script (Cursive)</MenuItem>
            <MenuItem value="'Great Vibes', cursive">Great Vibes (Cursive)</MenuItem>
            <MenuItem value="'Parisienne', cursive">Parisienne (Cursive)</MenuItem>
            <MenuItem value="'Tangerine', cursive">Tangerine (Cursive)</MenuItem>
          </Select>
        </FormControl>
      </Box>

      <Box sx={{ mb: 2 }}>
        <FormControl fullWidth size="small">
          <InputLabel>Font Weight</InputLabel>
          <Select
            value={styles?.fontWeight || 'normal'}
            onChange={(e) => updateAttrs({ styles: { fontWeight: e.target.value } })}
            label="Font Weight"
          >
            <MenuItem value="normal">Normal</MenuItem>
            <MenuItem value="bold">Bold</MenuItem>
            <MenuItem value="100">Thin</MenuItem>
            <MenuItem value="300">Light</MenuItem>
            <MenuItem value="400">Regular</MenuItem>
            <MenuItem value="500">Medium</MenuItem>
            <MenuItem value="600">Semi-Bold</MenuItem>
            <MenuItem value="700">Bold</MenuItem>
            <MenuItem value="900">Black</MenuItem>
          </Select>
        </FormControl>
      </Box>

      <Box sx={{ mb: 1 }}>
        <Typography type="s5" color='theme.secondary.800' weight='medium'>
          Font Size
        </Typography>
        <Slider
          value={styles?.fontSize}
          onChange={(_, value) => updateAttrs({ styles: { fontSize: value as number } })}
          min={10}
          max={40}
          step={1}
          valueLabelDisplay="auto"
          size="small"
          sx={(theme) => ({
            '& .MuiSlider-rail': {
              color: theme.palette.theme.primary[500],
            },
            '& .MuiSlider-thumb': {
              color: theme.palette.theme.primary[800],
            },
            '& .MuiSlider-track': {
              color: theme.palette.theme.primary[600],
            },
          })}
        />
      </Box>
      <Box sx={{ mb: 2, }}>
        <TextField
          label="Text Color"
          type="color"
          value={styles?.color}
          onChange={(e) => updateAttrs({ styles: { color: e.target.value } })}
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <ColorLensIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />
      </Box>
    </>
  );
};

export default SignatureControls;